export const changePageNumber = (
  queryParams: any,
  totalCount: number,
  entities: any[]
) => {
  const pageSize = queryParams.pageSize;
  const lastPageValue = (totalCount + pageSize - 1) / pageSize;
  const pageNumber = queryParams.pageNumber;
  if (
    lastPageValue === pageNumber &&
    entities.length - 1 === 0 &&
    totalCount > 1
  ) {
    return { ...queryParams, pageNumber: pageNumber - 1 };
  }
  return false;
};
